import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  whatsappLinkWrapper: theme => css`
    position: fixed;
    bottom: 0;
    right: ${theme.spacing.xxs};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    a {
      text-decoration: none;
    }

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      a {
        padding: ${theme.spacing.xs} ${theme.spacing.xxs};
      }
      p {
        display: none;
      }
    }
  `,
  whatsappLink: theme => css`
    margin: ${theme.spacing.xs};
    border: none;
    border-radius: ${theme.border.radius.full};
    padding: ${theme.spacing.xxs} ${theme.spacing.xs};
    display: flex;
    flex-direction: row;
    width: fit-content;
    align-items: center;
    background: ${theme.colors.brand.primary[300]};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  `,

  iconTalk: ({ spacing }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p {
      margin-left: ${spacing.xxs};
    }
  `,
})
export { useStyles }
